(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diferencia-roman"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__skinorvTsmdBound) return;
  window.__skinorvTsmdBound = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-tsmd-scroll-top]');
    if (!btn) return;
    e.preventDefault();
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      window.scrollTo(0, 0);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredientes-cards-roman"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sliders = document.querySelectorAll('[data-slin-slider]');
  sliders.forEach(function (slider) {
    const track = slider.querySelector('[data-slin-track]');
    const btnPrev = slider.querySelector('[data-slin-prev]');
    const btnNext = slider.querySelector('[data-slin-next]');
    if (!track || !btnPrev || !btnNext) return;

    function getStep() {
      const card = track.querySelector('.slin__card');
      if (!card) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scroll(dir) {
      track.scrollBy({ left: getStep() * dir, behavior: 'smooth' });
    }

    function updateArrows() {
      const max = track.scrollWidth - track.clientWidth;
      const left = track.scrollLeft;
      const atStart = left <= 4;
      const atEnd = left >= max - 4 || max <= 0;
      btnPrev.classList.toggle('slin__flecha--disabled', atStart);
      btnNext.classList.toggle('slin__flecha--disabled', atEnd);
    }

    btnPrev.addEventListener('click', function () { scroll(-1); });
    btnNext.addEventListener('click', function () { scroll(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    setTimeout(updateArrows, 50);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preguntas-roman"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__skinorvFaqBound) return;
  window.__skinorvFaqBound = true;

  document.addEventListener('toggle', function (e) {
    const item = e.target;
    if (!item || typeof item.hasAttribute !== 'function') return;
    if (!item.hasAttribute('data-faq-item')) return;
    if (!item.open) return;

    const grid = item.closest('[data-faq-grid]');
    if (!grid) return;

    const others = grid.querySelectorAll('[data-faq-item]');
    others.forEach(function (other) {
      if (other !== item && other.hasAttribute('open')) {
        other.removeAttribute('open');
      }
    });
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-result-roman"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sliders = document.querySelectorAll('[data-rres-slider]');
  sliders.forEach(function (slider) {
    const track = slider.querySelector('[data-rres-track]');
    const btnPrev = slider.querySelector('[data-rres-prev]');
    const btnNext = slider.querySelector('[data-rres-next]');
    if (!track || !btnPrev || !btnNext) return;

    function getStep() {
      const card = track.querySelector('.rres__card');
      if (!card) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scroll(dir) {
      track.scrollBy({ left: getStep() * dir, behavior: 'smooth' });
    }

    function updateArrows() {
      const max = track.scrollWidth - track.clientWidth;
      const left = track.scrollLeft;
      const atStart = left <= 4;
      const atEnd = left >= max - 4 || max <= 0;
      btnPrev.classList.toggle('rres__flecha--disabled', atStart);
      btnNext.classList.toggle('rres__flecha--disabled', atEnd);
    }

    btnPrev.addEventListener('click', function () { scroll(-1); });
    btnNext.addEventListener('click', function () { scroll(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    setTimeout(updateArrows, 50);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-roman"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__skinorvLovdBound) return;
  window.__skinorvLovdBound = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-lovd-read-more]');
    if (btn) {
      e.preventDefault();
      const wrap = btn.closest('[data-lovd-review]');
      if (!wrap) return;
      const expanded = wrap.getAttribute('data-expanded') === 'true';
      wrap.setAttribute('data-expanded', expanded ? 'false' : 'true');
      const textMore = btn.getAttribute('data-text-more') || 'Read More';
      const textLess = btn.getAttribute('data-text-less') || 'Read Less';
      btn.textContent = expanded ? textMore : textLess;
      return;
    }

    const prev = e.target.closest('[data-lovd-prev]');
    const next = e.target.closest('[data-lovd-next]');
    if (prev || next) {
      const slider = (prev || next).closest('[data-lovd-slider]');
      if (!slider) return;
      const track = slider.querySelector('[data-lovd-track]');
      if (!track) return;
      const card = track.querySelector('.lovd__card');
      if (!card) return;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const step = card.getBoundingClientRect().width + gap;
      track.scrollBy({ left: step * (prev ? -1 : 1), behavior: 'smooth' });
    }
  });

  function updateArrows(slider) {
    const track = slider.querySelector('[data-lovd-track]');
    const prev = slider.querySelector('[data-lovd-prev]');
    const next = slider.querySelector('[data-lovd-next]');
    if (!track || !prev || !next) return;
    const max = track.scrollWidth - track.clientWidth;
    const left = track.scrollLeft;
    prev.classList.toggle('lovd__flecha--disabled', left <= 4);
    next.classList.toggle('lovd__flecha--disabled', left >= max - 4 || max <= 0);
  }

  document.querySelectorAll('[data-lovd-slider]').forEach(function (slider) {
    const track = slider.querySelector('[data-lovd-track]');
    if (!track) return;
    track.addEventListener('scroll', function () { updateArrows(slider); }, { passive: true });
    setTimeout(function () { updateArrows(slider); }, 50);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-lovd-slider]').forEach(updateArrows);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
